import { Component } from '@angular/core';
import { IonicPage, NavController,LoadingController, NavParams } from 'ionic-angular';
import {CommonProvider} from "../../providers/common/common";
import {HomePage} from '../home/home';

/**
 * Generated class for the ThankuPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-thanku',
  templateUrl: 'thanku.html',
})
export class ThankuPage {
  strGetResponce:any="";
  arrGetResponce:any=[];
  token:any=""
  responceSuccess:any={};
  action:any=""
  constructor(public navCtrl: NavController, public navParams: NavParams,
    private cp: CommonProvider,private loadingCtrl:LoadingController,) {
  }

  ionViewDidLoad() {
    //console.log('ionViewDidLoad ThankuPage',this.navParams);
    // //console.log('ionViewDidLoad ThankuPage',JSON.parse(this.navParams.data.action));

     let loading = this.loadingCtrl.create({
          content: 'Please wait...'
        });
    this.strGetResponce = this.navParams.data.data;
    if(this.navParams.data.action){
      this.action = JSON.parse(JSON.parse(this.navParams.data.action)).paytmaction
      this.strGetResponce = JSON.parse(this.navParams.data.data); 
    }
    

    // //console.log('ionViewDidLoad ThankuPage',this.strGetResponce.split('|')[this.strGetResponce.split('|').length-1]);
    if(this.strGetResponce.split('|')[(this.strGetResponce.split('|').length)-1]=='techprocess'){
      var loan = localStorage.getItem("cc");
       this.cp.generateToken(loading,loan).then((res:any)=>{
          // loading.dismiss()
        var res=JSON.parse(res)
        this.token=res.TokenKey;
        this.updateTransaction(this.strGetResponce,'TECHPROCESSWEB')
      })


    }
    else if(this.action=='APP_CLOSED'){
      this.responceSuccess=JSON.parse(this.strGetResponce)
    }
    else{

       
        this.cp.verifyStatusPaytmPayment(loading,this.strGetResponce.split('|')[0]).then((res:any)=>{
          // loading.dismiss()
        var res=JSON.parse(res)
         //console.log(res.body)
         this.updateTransaction(res.body,'PAYTMWEB')
       })
    }

  }
   updateTransaction(resonce,type){
     let loading = this.loadingCtrl.create({
          content: 'Please wait...'
        });
        loading.present()





      this.cp.updatePayment(loading,resonce,type,this.token).then((res:any)=>{
        loading.dismiss();
        //console.log(res)
        this.responceSuccess=JSON.parse(res)
              // this.showAlert(res)
       })


    }
    goToHome(){
      this.navCtrl.setRoot(HomePage)
    }

}



// WEBPACK FOOTER //
// ./src/pages/thanku/thanku.ts